import { createFileRoute, redirect } from "@tanstack/react-router";

/** Redirect index to rules (exported for tests). */
export function notificationsIndexBeforeLoad() {
	throw redirect({ to: "/team/notifications/rules", replace: true });
}

/** Placeholder; navigation happens in `beforeLoad`. */
export function NotificationsIndexPlaceholder() {
	return null;
}

export const Route = createFileRoute("/_authorized/team/notifications/")({
	beforeLoad: notificationsIndexBeforeLoad,
	component: NotificationsIndexPlaceholder,
});
